import React, { useState, useEffect, useContext } from "react";
import { apis } from "../apis"; // Import your API functions
import { useFormik } from "formik";
import * as Yup from "yup";
import { KeyRound, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom"; // For navigation
import { useLocation } from "react-router-dom";
import { AuthContext } from "../AuthProvider";
import "./CheckOTP.css";

const CheckOTP = () => { // Mobile passed as a prop
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate(); // For navigation after success
  const location = useLocation();
  let mobile = location.state.mobile;
  const { login } = useContext(AuthContext);

  // Formik Validation Schema for OTP
  const validationSchema = Yup.object({
    otp: Yup.string().required("رمز التحقق مطلوب").length(6, "يجب أن يكون رمز التحقق 6 أرقام"),
  });

  // Formik Form
  const formik = useFormik({
    initialValues: {
      otp: "", // OTP value only, as mobile is passed as a prop
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      setError("");
      setMessage("");

      try {
        // Call the check OTP API with the mobile and otp values
        const response = await apis.checkOtp(mobile, values.otp);

        console.log(response)
        if (response.status === "success") {
          setMessage("تم التحقق بنجاح!");
          localStorage.setItem("token",response.token)
          login(response.token);

          setTimeout(() => {
           navigate("/dashboard"); // Redirect to dashboard or other screen after success
          }, 1000);
        } else {
          setError(response.msg || "فشل في التحقق من رمز OTP.");
        }
      } catch (err) {
        setError("حدث خطأ أثناء التحقق.");
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <div className="check-otp-container">
      <div className="check-otp-card">
        <h2 className="check-otp-title">التحقق من رمز OTP</h2>

        <form onSubmit={formik.handleSubmit} className="check-otp-form">
          {/* OTP Input */}
          <div className="form-group">
            <label htmlFor="otp">رمز التحقق</label>
            <div className="input-with-icon">
              <KeyRound size={18} className="input-icon" />
              <input
                id="otp"
                name="otp"
                type="text"
                placeholder="أدخل رمز التحقق"
                value={formik.values.otp}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className={formik.touched.otp && formik.errors.otp ? "error" : ""}
              />
            </div>
            {formik.touched.otp && formik.errors.otp && (
              <div className="error-message">{formik.errors.otp}</div>
            )}
          </div>

          {error && <div className="error-message">{error}</div>}
          {message && <div className="success-message">{message}</div>}

          <button
            type="submit"
            className="submit-button"
            disabled={loading}
          >
            {loading ? (
              <div className="loading-spinner"></div>
            ) : (
              <>
                <span>التحقق</span>
                <ArrowRight size={18} />
              </>
            )}
          </button>
        </form>

        <div className="resend-otp">
          <span>لم تتلق رمز OTP؟</span>
          <button 
            className="resend-button"
            onClick={() => navigate("/resend-otp")}
          >
            إعادة إرسال
          </button>
        </div>
      </div>
    </div>
  );
};

export default CheckOTP;
